<script lang="ts">
	import CarouselArrows from "@components/CarouselArrows.svelte";
	import Carousel from "@components/common/Carousel.svelte";
	import Media from "@components/common/Media.svelte";
	import type { MediaSrc } from "@components/common/MediaSrc.js";
	import type { EmblaCarouselType } from "embla-carousel";
	import type { ClassValue } from "svelte/elements";

	const {
		images,
		class: customClass,
		lightbox = crypto.randomUUID(),
	}: { images: MediaSrc[]; class?: ClassValue; lightbox?: string } = $props();

	function align(viewSize: number): number {
		let containerWidth: string | number = getComputedStyle(document.body).getPropertyValue("--container-width");
		if (containerWidth === "100%") {
			containerWidth = viewSize;
		} else {
			containerWidth = parseInt(containerWidth);
		}
		return (viewSize - containerWidth) / 2;
	}

	let api = $state<EmblaCarouselType>();
</script>

{#if images.length > 0}
	<div class={["flex flex-col gap-8", customClass]}>
		<Carousel items={images} bind:api options={{ loop: true, align, inViewThreshold: 0.75 }}>
			{#snippet item(image: MediaSrc, index: number, isDuplicated: boolean)}
				<Media
					lightbox={isDuplicated ? false : lightbox}
					class="aspect-[843/602] mx-0.5 object-cover"
					source={image}
					width={843}
					height={602}
					alt="Obrázek č. {index + 1}"
				/>
			{/snippet}
		</Carousel>
		<div class="grid-container">
			<CarouselArrows {api} slideCount={images.length} />
		</div>
	</div>
{/if}
